import { DomainEvent } from '../../../core/domain/events/domain_event';
import { Resource } from '../domain/resource';

export class ResourceEvent extends DomainEvent<Resource> {}

export class ResourceCreated extends ResourceEvent {}

export class ResourceUpdated extends ResourceEvent {}

export class ResourceDeactivate extends ResourceEvent {}

export class ResourceActivate extends ResourceEvent {}
